import { useRouter } from "next/router";
import { GalleryUI } from "./GalleryUI";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSocialProofMessages } from "@/components/Galleries/hooks/useSocialProofMessages";
import {
  standardComponent,
  useStandardProps,
} from "@/context/StandardPropsContext/StandardPropsContext";
import { isM2MRomanBlindOrCurtain } from "@/utils/product/isMadeToMeasure.ts";
import { filterM2MImages } from "@/components/Galleries/utils/filterM2MImages.ts";

export const Gallery = standardComponent("Gallery", () => {
  const { product, sizes } = useStandardProps();
  const { variant } = useVariant(product);
  const media = "media" in product ? product.media : null;
  const videos = media?.videos || [];
  const { socialProofMessagesProperties } = useSocialProofMessages();
  const router = useRouter();

  if (!variant) return null;

  let images = variant.images;
  if (isM2MRomanBlindOrCurtain(product)) {
    images = filterM2MImages(images, router.query);
  }

  return (
    <GalleryUI
      title={variant.title}
      images={images}
      videos={videos}
      sizes={sizes}
      hasSocialProofMessagesExperience={true}
      socialProofMessagesProperties={socialProofMessagesProperties}
    />
  );
});
